import React from "react";
import {DialogsContextState} from "./types/dialogsContextState";

export const DialogsContext = React.createContext<DialogsContextState | undefined>(undefined)
